import { useRecordContext, Button } from "react-admin";

export const ButtonNullable = ({ source, children, ...props }) => {
    const record = useRecordContext();

    if (!record || record[source] == null || record[source] === "") {
        return null;
    }

    return (
        <Button {...props}>
            {children}
        </Button>
    );
};